import { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    /*
    componentDidCatch(error, errorInfo) {
        logErrorToMyService(error, errorInfo);
    }
    */
    render() {
        if (this.state.hasError) {
        // You can render any custom fallback UI
            console.log('Something went wrong');
            return null;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
